import { createSlice } from '@reduxjs/toolkit';
import {
  fetchSentimentCount,
  fetchSentimentTrend,
  fetchTopicSummary,
  fetchDropdownCategories,
  fetchCategorySummary,
  fetchCategoryOverTime,
  fetchTrendingTopicsSearch,
  fetchCommentsReport,
  fetchDynamicSearchReport,
  fetchTreeReportTabsCount,
  fetchTreeReport,
  fetchTreeReportCategoryTopicComment,
  fetchTopVisitedSites,
  fetchTopRatedSites,
  fetchRatingDistribution,
  fetchSitesRatings,
} from './VocAPI';

export const initialState = {
  sentimentCount: { data: [], error: '', loading: !false },
  sentimentTrend: { data: [], error: '', loading: !false },
  trendingTopics: { data: [], error: '', loading: !false },
  categorySummary: { data: [], error: '', loading: !false },
  topVisitedSites: { data: [], error: '', loading: !false },
  topRatedSites: { data: [], error: '', loading: !false },
  ratingDistribution: { data: {}, error: '', loading: !false },
  sitesRatings: { data: [], error: '', loading: !false },
  dropdownCategories: { data: [], error: '', loading: !false },
  trendingTopicsSearch: { data: [], error: '', loading: !false },
  treeReportTabsCount: { data: [], error: '', loading: !false },
  treeReport: { data: [], error: '', loading: !false },
  treeReportTopicsComments: {
    data: { categoryComments: [], trendingTopics: [] },
    error: '',
    loading: !false,
  },
  dynamicSearch: {
    data: { count: null, data: [] },
    error: '',
    loading: !false,
  },
  commenstList: {
    data: { comments: [], total: [] },
    error: '',
    loading: !false,
  },
  categoryOverTime: {
    data: {
      yearlyCategoriesOverTime: [],
      categoriesOverTimeBar: [],
    },
    error: '',
    loading: !false,
  },
  filters: {
    sourceType: { value: 0, label: 'All' },
    categoryData: {
      level: 1,
      id: null,
      label: 'All Categories',
      categories: [],
      trackCategories: [],
    },
  },
  sentimentType: {
    value: 0,
    label: 'Overall',
  },
};

export const VocSlice = createSlice({
  name: 'voc',
  initialState: initialState,
  reducers: {
    setSourceType: (state, action) => {
      state.filters.sourceType = action.payload;
    },
    setCategoryData: (state, action) => {
      state.filters.categoryData = action.payload;
    },
    setSentimentType: (state, action) => {
      state.sentimentType = action.payload;
    },
    clearTrendingTopicsSearch: (state, action) => {
      state.trendingTopicsSearch.loading = false;
      state.trendingTopicsSearch.data = [];
      state.trendingTopicsSearch.error = '';
    },
    clearDynamicSearch: (state, action) => {
      state.dynamicSearch.loading = false;
      state.dynamicSearch.data = { count: null, data: [] };
      state.dynamicSearch.error = '';
    },
  },
  extraReducers: {
    [fetchSentimentCount.pending]: (state) => {
      state.sentimentCount.loading = true;
    },
    [fetchSentimentCount.rejected]: (state, { meta, error }) => {
      state.sentimentCount.loading = false;
      state.sentimentCount.data = [];
      state.sentimentCount.error = error;
    },
    [fetchSentimentCount.fulfilled]: (state, { meta, payload: { data } }) => {
      state.sentimentCount.loading = false;
      state.sentimentCount.error = '';
      state.sentimentCount.data = data;

      console.log('state.data = data.fetchSentimentCount');
      console.log(data);
    },
    [fetchSentimentTrend.pending]: (state) => {
      state.sentimentTrend.loading = true;
    },
    [fetchSentimentTrend.rejected]: (state, { meta, error }) => {
      state.sentimentTrend.loading = false;
      state.sentimentTrend.data = [];
      state.sentimentTrend.error = error;
    },
    [fetchSentimentTrend.fulfilled]: (state, { meta, payload: { data } }) => {
      state.sentimentTrend.loading = false;
      state.sentimentTrend.error = '';
      state.sentimentTrend.data = data;

      console.log('state.data = data.fetchSentimentTrend');
      console.log(data);
    },
    [fetchTopicSummary.pending]: (state) => {
      state.trendingTopics.loading = true;
    },
    [fetchTopicSummary.rejected]: (state, { meta, error }) => {
      state.trendingTopics.loading = false;
      state.trendingTopics.data = [];
      state.trendingTopics.error = error;
    },
    [fetchTopicSummary.fulfilled]: (state, { meta, payload: { data } }) => {
      state.trendingTopics.loading = false;
      state.trendingTopics.error = '';
      state.trendingTopics.data = data;

      console.log('state.data = data.fetchTopicSummary');
      console.log(data);
    },
    [fetchCategorySummary.pending]: (state) => {
      state.categorySummary.loading = true;
    },
    [fetchCategorySummary.rejected]: (state, { meta, error }) => {
      state.categorySummary.loading = false;
      state.categorySummary.data = [];
      state.categorySummary.error = error;
    },
    [fetchCategorySummary.fulfilled]: (state, { meta, payload: { data } }) => {
      state.categorySummary.loading = false;
      state.categorySummary.error = '';
      state.categorySummary.data = data;

      console.log('state.data = data.fetchCategorySummary');
      console.log(data);
    },

    [fetchCategoryOverTime.pending]: (state) => {
      state.categoryOverTime.loading = true;
    },
    [fetchCategoryOverTime.rejected]: (state, { meta, error }) => {
      state.categoryOverTime.loading = false;
      state.categoryOverTime.data = {
        yearlyCategoriesOverTime: [],
        categoriesOverTimeBar: [],
      };
      state.categoryOverTime.error = error;
    },
    [fetchCategoryOverTime.fulfilled]: (state, { meta, payload: { data } }) => {
      state.categoryOverTime.loading = false;
      state.categoryOverTime.error = '';
      state.categoryOverTime.data = data;
    },

    [fetchDropdownCategories.pending]: (state) => {
      state.dropdownCategories.loading = true;
    },
    [fetchDropdownCategories.rejected]: (state, { meta, error }) => {
      state.dropdownCategories.loading = false;
      state.dropdownCategories.data = [];
      state.dropdownCategories.error = error;
    },
    [fetchDropdownCategories.fulfilled]: (
      state,
      { meta, payload: { data } }
    ) => {
      state.dropdownCategories.loading = false;
      state.dropdownCategories.error = '';
      state.dropdownCategories.data = data;
      let parentNode = data[0].data[0].nodes;
      //IF Reducer Already Have Data Then Do Nothing
      if (state.filters.categoryData.categories.length > 0) {
      } else {
        state.filters.categoryData.categories = parentNode;
        state.filters.categoryData.trackCategories.push({
          levelName: 'All Categories',
          id: 1,
          name: 1,
          categoriesList: parentNode,
        });
      }
    },
    [fetchTrendingTopicsSearch.pending]: (state) => {
      state.trendingTopicsSearch.loading = true;
    },
    [fetchTrendingTopicsSearch.rejected]: (state, { meta, error }) => {
      state.trendingTopicsSearch.loading = false;
      state.trendingTopicsSearch.data = [];
      state.trendingTopicsSearch.error = error;
    },
    [fetchTrendingTopicsSearch.fulfilled]: (
      state,
      { meta, payload: { data } }
    ) => {
      state.trendingTopicsSearch.loading = false;
      state.trendingTopicsSearch.error = '';
      state.trendingTopicsSearch.data = data;
    },

    [fetchCommentsReport.pending]: (state) => {
      state.commenstList.loading = true;
    },
    [fetchCommentsReport.rejected]: (state, { meta, error }) => {
      state.commenstList.loading = false;
      state.commenstList.data = {
        comments: [],
        total: [],
      };
      state.commenstList.error = error;
    },
    [fetchCommentsReport.fulfilled]: (state, { meta, payload: { data } }) => {
      state.commenstList.loading = false;
      state.commenstList.error = '';
      state.commenstList.data = data;
      var hasCount = data[0].total.some((value) => {
        return typeof value == 'object';
      });
      state.commenstList.data = {
        comments: data[0].comments,

        total: hasCount ? data[0].total[0].count : 0,
      };
    },

    [fetchDynamicSearchReport.pending]: (state) => {
      state.dynamicSearch.loading = true;
    },
    [fetchDynamicSearchReport.rejected]: (state, { meta, error }) => {
      state.dynamicSearch.loading = false;
      state.dynamicSearch.data = { count: null, data: [] };
      state.dynamicSearch.error = error;
    },
    [fetchDynamicSearchReport.fulfilled]: (
      state,
      { meta, payload: { data } }
    ) => {
      state.dynamicSearch.loading = false;
      state.dynamicSearch.error = '';
      state.dynamicSearch.data = {
        data: [...state.dynamicSearch.data.data, ...data.data],
        count: data.count,
      };
    },

    [fetchTreeReportTabsCount.pending]: (state) => {
      state.treeReportTabsCount.loading = true;
    },
    [fetchTreeReportTabsCount.rejected]: (state, { meta, error }) => {
      state.treeReportTabsCount.loading = false;
      state.treeReportTabsCount.data = [];
      state.treeReportTabsCount.error = error;
    },
    [fetchTreeReportTabsCount.fulfilled]: (
      state,
      { meta, payload: { data } }
    ) => {
      state.treeReportTabsCount.loading = false;
      state.treeReportTabsCount.error = '';
      state.treeReportTabsCount.data = data;
    },

    [fetchTreeReport.pending]: (state) => {
      state.treeReport.loading = true;
    },
    [fetchTreeReport.rejected]: (state, { meta, error }) => {
      state.treeReport.loading = false;
      state.treeReport.data = [];
      state.treeReport.error = error;
    },
    [fetchTreeReport.fulfilled]: (state, { meta, payload: { data } }) => {
      state.treeReport.loading = false;
      state.treeReport.error = '';
      state.treeReport.data = data;
    },

    [fetchTreeReportCategoryTopicComment.pending]: (state) => {
      state.treeReportTopicsComments.loading = true;
    },
    [fetchTreeReportCategoryTopicComment.rejected]: (
      state,
      { meta, error }
    ) => {
      state.treeReportTopicsComments.loading = false;
      state.treeReportTopicsComments.data = {
        CategoryComments: [],
        TrendingTopics: [],
      };
      state.treeReportTopicsComments.error = error;
    },
    [fetchTreeReportCategoryTopicComment.fulfilled]: (
      state,
      { meta, payload: { data } }
    ) => {
      state.treeReportTopicsComments.loading = false;
      state.treeReportTopicsComments.error = '';
      state.treeReportTopicsComments.data = {
        categoryComments: data.categoryComments,
        trendingTopics: data.trendingTopics,
      };
    },

    [fetchTopVisitedSites.pending]: (state) => {
      state.topVisitedSites.loading = true;
    },
    [fetchTopVisitedSites.rejected]: (state, { meta, error }) => {
      state.topVisitedSites.loading = false;
      state.topVisitedSites.data = [];
      state.topVisitedSites.error = error;
    },
    [fetchTopVisitedSites.fulfilled]: (state, { meta, payload: { data } }) => {
      state.topVisitedSites.loading = false;
      state.topVisitedSites.error = '';
      state.topVisitedSites.data = data;
    },

    [fetchTopRatedSites.pending]: (state) => {
      state.topRatedSites.loading = true;
    },
    [fetchTopRatedSites.rejected]: (state, { meta, error }) => {
      state.topRatedSites.loading = false;
      state.topRatedSites.data = [];
      state.topRatedSites.error = error;
    },
    [fetchTopRatedSites.fulfilled]: (state, { meta, payload: { data } }) => {
      state.topRatedSites.loading = false;
      state.topRatedSites.error = '';
      state.topRatedSites.data = data;
    },

    [fetchRatingDistribution.pending]: (state) => {
      state.ratingDistribution.loading = true;
    },
    [fetchRatingDistribution.rejected]: (state, { meta, error }) => {
      state.ratingDistribution.loading = false;
      state.ratingDistribution.data = {};
      state.ratingDistribution.error = error;
    },
    [fetchRatingDistribution.fulfilled]: (
      state,
      { meta, payload: { data } }
    ) => {
      state.ratingDistribution.loading = false;
      state.ratingDistribution.error = '';
      state.ratingDistribution.data = data;
    },

    [fetchSitesRatings.pending]: (state) => {
      state.sitesRatings.loading = true;
    },
    [fetchSitesRatings.rejected]: (state, { meta, error }) => {
      state.sitesRatings.loading = false;
      state.sitesRatings.data = {};
      state.sitesRatings.error = error;
    },
    [fetchSitesRatings.fulfilled]: (state, { meta, payload: { data } }) => {
      state.sitesRatings.loading = false;
      state.sitesRatings.error = '';
      state.sitesRatings.data = data;
    },
  },
});
export const {
  setSourceType,
  setCategoryData,
  setSentimentType,
  clearTrendingTopicsSearch,
  clearDynamicSearch,
} = VocSlice.actions;
export default VocSlice.reducer;
